import { Factor } from 'api/rtk-api'

export function getRecordFromFactor(factors: Factor[]): Record<string, number> {
  const record: Record<string, number> = {}
  factors.forEach(factor => {
    record[factor.timestamp] = factor.value
  })
  return record
}
